import { render, staticRenderFns } from "./ProduksiEgg.vue?vue&type=template&id=05a91e61&"
import script from "./ProduksiEgg.vue?vue&type=script&lang=js&"
export * from "./ProduksiEgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports